import { UserRole } from '../../enums/user';

export const shouldBypassStatisticsCacheForSuperAdmin = (role: unknown): boolean =>
  Number(role) === UserRole.sAdmin;
